import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        {
          key: 'CloudByte株式会社',
          title: 'CloudByte株式会社',
          href: '',
          blankTarget: true,
        },
      ]}
      copyright="2023-2026"
    />
  );
};

export default Footer;
